/**
 * @file firebaseConfig.ts
 * @description Initializes Firebase SDK and exports Auth instance for frontend authentication.
 */

import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import config from "./config";

const app = initializeApp(config.firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

const initializeFirebase = () => {
  logEvent(analytics, "app_initialized");
};

export { auth, googleProvider, initializeFirebase };
